<template>
  <span class="novedad" v-if="enable">Új</span>
</template>
<script>
export default {
  props: {
    enable: Boolean
  }
}
</script>
<style scoped>
  .novedad {
    border-radius: 2px;
    background: #ef5151;
    color: white;
    font-family: arial;
    font-weight: bolder;
    line-height: 20px;
    height: 20px;
    text-transform: uppercase;
    padding: 0 5px;
  }
</style>
